export const HOMEPAGE_LAYOUT_MAIN_CONTENT_CONTAINER_ID =
  "page-main-content-container";

export const PRIMARY_NAVIGATION_V3_CONTAINER_ID = "primary-navigation-v3";

//Currently scroll container
//TODO rename
export const PRIMARY_NAVIGATION_CONTENT_CONTAINER_ID =
  "primary-navigation-content-container";

export const LISTS_ADD_LEAD_MENU_ID = "add-leads-button-menu";

export const LISTS_START_CALLING_BUTTON_ID = "start-calling-button";

export const LISTS_ACCOUNT_DETAILS_SUMMARY_SECTION_ID =
  "account-details-summary-section";

export const LIST_SELECTOR_MENU_ID = "list-selector-menu";

export const LIST_SELECTOR_MENU_TRIGGER_ID = "list-selector-menu-trigger";
